import { ref, computed } from "vue";
import { useChatStore } from "@/stores/chatStore";
import { chatroomStore } from "../stores/messagesStore";
import { useTenantStore } from "@/stores/tenant";
import { agentDetails } from "@/stores/contactsStore";
import { useLabelsStore } from "@/stores/labels";

const chatId = ref(null);
const chatLetter = ref("");
const chatTitle = ref("");
const commonGroups = ref([]);
const multicontent = ref({});
export function useMessenger() {
    const ChatStore = useChatStore();
    const title = ref("");
    const titleInitials = ref("");
    const membersList = ref([]);
    const TenantStore = useTenantStore();
    const LabelsStore = useLabelsStore();

    const tenantDetails = TenantStore.getTenant;
    const agentId = agentDetails.agentId;

    const updateChatTitle = (room) => {
        if (!room) return;
        chatId.value = room._id;
        if (room.chatName === "1:1") {
            const contact = room.users?.find((user) => user.role === "Contact");
            chatTitle.value = contact ? `${contact.firstName || ""} ${contact.lastName || ""}`.trim() : "Chat";

            chatLetter.value = contact?.firstName?.charAt(0);
        } else {
            chatTitle.value = room.chatName ?? "Group Chat";
            chatLetter.value = room.chatName?.charAt(0);
        }
    };

    const handleMultiContent = (room) => {
        if (!room?.chatName || !room?.users) return;

        if (room.chatName !== "1:1") {
            title.value = room.chatName;
            multicontent.value = {
                type: "group",
                active: false,
                live: false,
                contact_icon: room.users?.slice(0, 4).map((user) => ({
                    text: `${user.firstName?.[0] || ""}${user.lastName?.[0] || ""}`,
                    firstName: user.firstName?.[0],
                    lastName: user.lastName?.[0] || "",
                    pic: user.pic,
                })),
                isDetail: true,
                name: room.chatName,
                message: room?.users
                    ?.filter((user) => user.role === "Contact")
                    .slice(0, 4)
                    .map((user) => user.firstName)
                    .join(", "),
                message_icons: "",
                message_icon_color: "",
                newlead: "",
                star_icon: { active: false },
            };

            membersList.value = room.users
                ?.filter((user) => user.role === "Contact")
                .map((user) => {
                    const phone = user.phone && user.phone.slice(0, user.phone.indexOf("@"));
                    return {
                        peer_id: user._id,
                        live: false,
                        contact_icon: {
                            text: "AT",
                            color: "pink-500",
                            pic: user.pic,
                            firstName: user.firstName || "",
                            lastName: user.lastName || "",
                        },
                        name: `${user.firstName || ""} ${user.lastName || ""}`,
                        message: `${user.email} ${phone && phone !== "null" ? `- ${phone}` : ""}`,
                        newlead: false,
                        star_icon: { active: false },
                    };
                });

            const updatedChat = ChatStore.chat_list.find((chat) => chat._id === chatId);
            if (updatedChat) {
                chatroomStore.activeChatContact = updatedChat;
                handleMultiContent(updatedChat);
            }
        } else if (room.chatName === "1:1") {
            const contactUser = room.users.find((user) => user.role === "Contact");
            if (contactUser) {
                title.value = `${contactUser?.firstName || ""} ${contactUser?.lastName || ""}`;
                titleInitials.value = getInitials(contactUser);
                const groups = ChatStore.getCommonGroups(contactUser.uuid);
                console.log(groups, "groups");
                if (groups.length > 0) {
                    const createMessage = (group) => {
                        const contacts = group.users
                            .filter((user) => user.role === "Contact")
                            .map((user) => user.firstName);

                        if (contacts.length > 3) {
                            const firstThreeContacts = contacts.slice(0, 3);
                            const remainingContacts = contacts.length - 3;
                            return `${firstThreeContacts.join(", ")}, and ${remainingContacts} more`;
                        } else {
                            if (contacts.length === 2) {
                                return contacts.join(" and ");
                            } else if (contacts.length === 3) {
                                const firstTwoContact = contacts.slice(0, 2);
                                const lastContact = contacts[2];
                                return `${firstTwoContact.join(", ")}, and ${lastContact}`;
                            } else if (contacts.length === 1) {
                                return contacts.join("");
                            }
                        }
                    };
                    commonGroups.value = groups.map((group) => ({
                        _id: group._id,
                        actual_data: group,
                        multicontent: {
                            type: "group",
                            active: false,
                            live: false,
                            contact_icon: group.users
                                // .filter((user) => user.role === 'Contact')
                                .slice(0, 4)
                                .map((user) => ({
                                    text: `${user.firstName?.[0] || ""}${user.lastName?.[0] || ""}`,
                                    firstName: user.firstName?.[0],
                                    lastName: user.lastName?.[0] || "",
                                    icon: "",
                                    pic: user.pic,
                                })),
                            name: group.chatName,
                            message: createMessage(group),
                            message_icons: "",
                            message_icon_color: "",
                            newlead: "",
                            star_icon: { active: false },
                        },
                    }));
                    multicontent.value = commonGroups[0]?.multicontent;
                } else {
                    commonGroups.value = [];
                }
            }
        } else {
            commonGroups.value = [];
        }
    };
    const getInitials = (user) => {
        return `${(user.firstName?.[0] || "").toUpperCase()}${(user.lastName?.[0] || "").toUpperCase()}` || "X";
    };

    function getUserByRole(role) {
    return chatroomStore.activeChatContact.users?.find(user => user.role === role);
}
    return {
        agentId,
        chatId,
        chatLetter,
        chatTitle,
        commonGroups,
        getInitials,
        getUserByRole,
        handleMultiContent,
        membersList,
        multicontent,
        tenantDetails,
        title,
        titleInitials,
        updateChatTitle
    };
}
